import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { PageResponse } from '../../_shared/types/shared';
import type { ApiRow, ApiFormValues, ApiFilters, AuthPolicyOption, RateLimitPolicy, DiscoverSummary } from '../types/api';

export const apisApi = {
  list: async (params: ApiFilters & { page: number; size: number; sort?: string }) => {
    const response = await gatewayApiClient.get<PageResponse<ApiRow>>('/apis', { params });
    return response.data;
  },

  get: async (id: string) => {
    const response = await gatewayApiClient.get<ApiRow>(`/apis/${id}`);
    return response.data;
  },

  create: async (body: ApiFormValues) => {
    const response = await gatewayApiClient.post<ApiRow>('/apis', body);
    return response.data;
  },

  replace: async (id: string, body: ApiFormValues) => {
    const response = await gatewayApiClient.put<ApiRow>(`/apis/${id}`, body);
    return response.data;
  },

  patch: async (id: string, body: Partial<ApiFormValues>) => {
    const response = await gatewayApiClient.patch<ApiRow>(`/apis/${id}`, body);
    return response.data;
  },

  delete: async (id: string) => {
    await gatewayApiClient.delete(`/apis/${id}`);
  },

  deprecate: async (id: string) => {
    const response = await gatewayApiClient.post<ApiRow>(`/apis/${id}/deprecate`);
    return response.data;
  },

  /**
   * #473: POST /api/eraf/gateway/apis/discover — API 자동수집.
   * ROLE_EXEC 는 BE 가 423(GATEWAY-423-003) 반환.
   */
  discover: async (): Promise<DiscoverSummary> => {
    const response = await gatewayApiClient.post<DiscoverSummary>('/apis/discover');
    return response.data;
  },

  listAuthPolicies: async (): Promise<AuthPolicyOption[]> => {
    // Static options — backend may return them dynamically
    try {
      const response = await gatewayApiClient.get<AuthPolicyOption[]>('/auth-policies');
      return response.data;
    } catch {
      return [
        { value: 'none', label: '없음' },
        { value: 'jwt', label: 'JWT' },
        { value: 'api-key', label: 'API Key' },
        { value: 'oauth2', label: 'OAuth2' },
      ];
    }
  },

  listRateLimitPolicies: async (): Promise<RateLimitPolicy[]> => {
    const response = await gatewayApiClient.get<PageResponse<RateLimitPolicy>>(
      '/rate-limit-policies',
      { params: { size: 100 } }
    );
    return response.data.content;
  },
};
